import { styled } from '@ori-ui/mui';
import type { PropsWithChildren } from 'react';
import React from 'react';

import { maxWidth } from '../../constants';
import { useFooterContext } from '../../hooks';
import { MobileOfficeRoot } from '../MobileOffice';

const Root = styled(MobileOfficeRoot)(({ theme }) => ({
  display: 'flex',
  maxWidth,
  flexDirection: 'column',
  margin: theme.spacing(0, 'auto', 6),
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 6),
  },
}));

export const ContentRoot: React.FC<PropsWithChildren> = ({ children }) => {
  const { isMobileOffice } = useFooterContext();

  return <Root isMobileOffice={isMobileOffice}>{children}</Root>;
};
